import { useMemo } from 'react';

function useFormatedAndFilteredEvents({ query = '', events }) {
  return useMemo(() => {
    const now = new Date();

    return events
      .map(event => ({
        ...event,
        title: event.title,
        start: new Date(event.start_at),
        end: new Date(event.end_at)
      }))
      .filter(
        ({ title, start, end }) =>
          (!query ? true : title.toLowerCase().includes(query.toLowerCase())) && (start >= now || end >= now)
      );
  }, [query, events]);
}

export default useFormatedAndFilteredEvents;
